<div class="layout-auto-1-auto">
  <div class="app-section-header">
    <h2>Anwendungseinstellungen</h2>
  </div>
  <div class="content">
    <div class="dashboard-tile-container">
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide"  style="cursor: pointer" (click)="openDefaultOE($event)">
          <em>Default OE</em>
        </div>
      </div>
      <div *ngIf="excSecurity.isFeatured('SETGLOBAL')" class="dashboard-tile-container-medium-wide" >
        <div class="dashboard-tile-small-wide"  style="cursor: pointer" (click)="openGlobal($event)">
          <em>Globale Einstellungen</em>
        </div>
      </div>
    </div>
    <h6>Auftrag <i class="far fa-ellipsis-v md-btn-circular"></i>
    </h6>
    <div class="dashboard-tile-container">
      <div *ngIf="excSecurity.isFeatured('SETAUTOTEXT')"  class="dashboard-tile-container-medium-wide" >
        <div class="dashboard-tile-small-wide" style="cursor: pointer" (click)="openCaseAutoText($event)">
          <em>Email-Texte</em>
        </div>
      </div>
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide" style="cursor: pointer" (click)="openCaseDefaultMessage($event)">
          <em>Standardnachrichten</em>
        </div>
      </div>
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide" style="cursor: pointer" (click)="openCaseDefaultDocuments($event)">
          <em>Standarddokumente</em>
        </div>
      </div>
    </div>
    <h6>Vorgang <i class="far fa-ellipsis-v md-btn-circular"></i>
    </h6>
    <div class="dashboard-tile-container">
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide"  style="cursor: pointer" (click)="openTaskScheduleTemplate($event)">
          <em>Ablaufplanvorlagen</em>
        </div>
      </div>
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide"  style="cursor: pointer" (click)="openTaskForms($event)">
          <em>Formulare</em>
        </div>
      </div>
      <div *ngIf="excSecurity.isFeatured('SETAUTOTEXT')" class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide" style="cursor: pointer" (click)="openTaskAutoText($event)">
          <em>Email-Texte</em>
        </div>
      </div>
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide" style="cursor: pointer" (click)="openTaskDefaultMessage($event)">
          <em>Standardnachrichten</em>
        </div>
      </div>
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide" style="cursor: pointer" (click)="openTaskDefaultDocuments($event)">
          <em>Standarddokumente</em>
        </div>
      </div>
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide"  style="cursor: pointer" (click)="openTaskDialogQuestions($event)">
          <em>Dialogfragen</em>
        </div>
      </div>
    </div>
  </div>
  <div></div>
</div>
